import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  stylesOverride: {
    marginBottom: 1.875 * unit
  }
});

const themeOverride = ({ palette: { error } }) => ({
  errorColor: error.dark
});

export default createUseStyles(styles);

export { themeOverride };
